export * from './setupLegacyInterop';

import { ReplaySubject } from '@reactivex/rxjs';

export const toggleZoomIn = new ReplaySubject(1);
export const toggleCenter = new ReplaySubject(1);
export const toggleZoomOut = new ReplaySubject(1);

export const hitmapUpdates = new ReplaySubject(1);
export const cameraChanges = new ReplaySubject(1);
export const isAnimating = new ReplaySubject(1);
export const labelSettings = new ReplaySubject(1);
export const simulateOn = new ReplaySubject(1);

// Declare implicit dependencies that we're currently hard-coded to anyway.
export const curPoints = new ReplaySubject(1);
export const edgeColors = new ReplaySubject(1);
export const pointSizes = new ReplaySubject(1);
export const pointColors = new ReplaySubject(1);
export const forwardsEdgeStartEndIdxs = new ReplaySubject(1);
export const forwardsEdgeToUnsortedEdge = new ReplaySubject(1);
export const logicalEdges = new ReplaySubject(1);

// These are calculated in redering-scheduler and updated there.
export const backwardsEdgeToUnsortedEdge = new ReplaySubject(1);
export const backwardsEdgeStartEndIdxs = new ReplaySubject(1);